import { render } from "./lhbd.vue?vue&type=template&id=453c418e&scoped=true&ts=true"
import script from "./lhbd.vue?vue&type=script&lang=ts"
export * from "./lhbd.vue?vue&type=script&lang=ts"

import "./lhbd.vue?vue&type=style&index=0&id=453c418e&lang=less&scoped=true"

import exportComponent from "E:\\operationmanual\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453c418e"]])

export default __exports__